import React from "react";
import { useNavigate } from "react-router-dom";
import "./Itinerary.css";
import sigiriyaImg from "./sigiriyaRock.jpg";
import kandyImg from "./Ktemple.png";
import nuwaraImg from "./greg.jpg";
import ellaImg from "./ellaTrain.jpg";
import { useTranslation } from "./hooks/useTranslation";

const Package2Details = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBookNow = () => {
    navigate("/buy");
  };

  const packageInfo = {
    duration: t.package2Duration,
    charges: t.package2Charges,
    hotel: t.package2Hotel,
    price: t.package2Price
  };

  const locationsData = t.package2Locations || [];

  const locationImages = [
    { image: sigiriyaImg, alt: "Sigiriya" },
    { image: kandyImg, alt: "Kandy" },
    { image: nuwaraImg, alt: "Nuwara Eliya" },
    { image: ellaImg, alt: "Ella" },
  ];

  return (
    <div className="itinerary-wrapper">
      <header className="itinerary-header">
        <h1>{t.package2Title}</h1>
        <div className="package-info-section">
          <p className="intro-text">
            <strong>{packageInfo.duration}</strong>
          </p>
          <p className="intro-text">{packageInfo.charges}</p>
          <p className="intro-text">{packageInfo.hotel}</p>
          <p className="intro-text">
            <strong style={{ color: "#1a73e8", fontSize: "1.2rem" }}>
              {packageInfo.price}
            </strong>
          </p>
        </div>
      </header>

      {/* Book Now button above itinerary, right aligned */}
      <div className="book-now-wrapper top-right">
        <button className="book-now-button" onClick={handleBookNow}>
          {t.bookNow}
        </button>
      </div>

      <div className="itinerary-cards-container">
        {locationsData.map((location, index) => {
          const imageObj = locationImages[index] || {};
          return (
            <div key={index} className="itinerary-card">
              <div className="card-header">
                <div className="day-badge">{location.name}</div>
              </div>

              <div className="card-content">
                {imageObj.image && (
                  <img 
                    src={imageObj.image} 
                    alt={imageObj.alt || location.name} 
                    className="activity-image"
                  />
                )}
                <h3>{t.package2Activities}</h3>
                <div className="activity-details">
                  {location.activities.map((activity, i) => (
                    <div key={i} className="activity-item">
                      <h4 className="activity-title">{activity.title}</h4>
                      <p className="activity-desc">{activity.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Package2Details;

